import React from "react";

const IconWithRoundedBorder = ({outerColor,boxColor,paddingBox,innerColor,FonCompo}) => {

    const bordertyle={
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: `2px solid ${outerColor||'red'}`, // Outer border
        borderRadius: '50%', // Circular shape
        padding: `${paddingBox || '6px'}`, // Space between icon and border
       // boxShadow:`5px 5px 5px ${boxColor||'#bdbdbd'}`,
        backgroundColor:`${innerColor||'red'}`
      };
      
  return (
      <div style={bordertyle}>
        {FonCompo}
      </div>
  );
};


export default IconWithRoundedBorder;
